module.exports = __webpack_public_path__ + "static/media/semiTractorNoTrailer_red.54a26906.svg";